import * as React from 'react';
import { Html } from '../../helpers/html-helpers';

interface IPerformanceMessagingProps {
    performanceMessaging: string;
}

class AppMenu extends React.PureComponent<IPerformanceMessagingProps, { hideMessaging: boolean }>{
    constructor(props) {
        super(props);
        this.state = { hideMessaging: false };
    }
    render() {
        const useTagCloseicon = '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close" />';

        var openClass = "alert-container";
        if (!this.state.hideMessaging) {
            openClass += " alert-container-open";
            document.getElementById('app-container').classList.add('alert-container-active');

        }
        return (
            <div className={openClass}>
                <div className="alert-container-inner">

                    {Html.renderParagraph(this.props.performanceMessaging, "caption-paragraph")}

                    <a href="#" onClick={this._alertCloseClick.bind(this)}>
                        <svg className="alert-close-icon" dangerouslySetInnerHTML={{ __html: useTagCloseicon }} ></svg>
                    </a>
                </div>

            </div>
        );
    }

    _alertCloseClick(evt) {
        evt.preventDefault();
        this.setState({ hideMessaging: true });
        document.getElementById('app-container').classList.remove('alert-container-active');
    }

}

export default AppMenu;
